import { useEnvironment } from '@publicisgroupe/p-os-components';
import { ConfigApiProvider } from '@publicisgroupe/pm-os-config-frontend';
import { ReactNode } from 'react';

export const ConfigProvider = ({ children }: { children: ReactNode }) => {
  const environment = useEnvironment();
  const bearerToken = (window as any)?.bearerToken;

  return (
    <ConfigApiProvider
      initialState={{
        apiBaseUrl: `${environment?.settings?.apiBaseURL}/webframe`,
        apiPath: 'api/configmodule/',
        headers: [
          {
            key: 'Ocp-Apim-Subscription-Key',
            value: environment?.settings?.ocpApimKey,
          },
          {
            key: 'authorization',
            value: `Bearer ${bearerToken}`,
          },
        ],
        xdmSettings: {
          baseUrl: `${environment?.settings?.apiBaseURL}/xdmservice`,
          headers: [
            {
              key: 'Ocp-Apim-Subscription-Key',
              value: environment?.settings?.ocpApimKey,
            },
            {
              key: 'authorization',
              value: `Bearer ${bearerToken}`,
            },
          ],
        },
      }}
    >
      {children}
    </ConfigApiProvider>
  );
};
